export enum GroupingBase {
  Overall = "OVERALL",
}
